import {Component, OnInit} from '@angular/core';
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {Setting} from "../../dto/Setting";
import {TabViewModule} from "primeng/tabview";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-admin-setting-page',
    standalone: true,
    imports: [
        TabViewModule,
        FormsModule
    ],
    templateUrl: './admin-setting-page.component.html',
    styleUrl: './admin-setting-page.component.css'
})
export class AdminSettingPageComponent extends AdminTemplateComponent implements OnInit {

    selectedSetting: Setting = new Setting();
    listPagesConfig = {
        success: {text: ''},
        features: {text: ''},
        pages: {text: ''},
        blogs: {text: ''},
        news: {text: ''},
        customers: {text: ''},
    };
    dashboardSetting = {
        loginUrl: ""
    };

    ngOnInit() {
        this.loadPagesList();
        this.loadDashBoardSetting();
    }


    loadPagesList() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/setting/get_setting?" +
            "&type=LIST_PAGES");
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.selectedSetting = res["entity"];
                    if (this.selectedSetting.data != null) {
                        this.listPagesConfig = JSON.parse(this.selectedSetting.data);
                    }


                    if (this.listPagesConfig.news == null) {
                        this.listPagesConfig.news={text: ''};
                    }
                    if (this.listPagesConfig.success == null) {
                        this.listPagesConfig.success={text: ''};
                    }
                    if (this.listPagesConfig.pages == null) {
                        this.listPagesConfig.pages={text: ''};
                    }
                    if (this.listPagesConfig.blogs == null) {
                        this.listPagesConfig.blogs={text: ''};
                    }
                    if (this.listPagesConfig.features == null) {
                        this.listPagesConfig.features={text: ''};
                    }
                    if (this.listPagesConfig.customers == null) {
                        this.listPagesConfig.customers={text: ''};
                    }
                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    savePagesList() {
        let params = {};
        this.selectedSetting.data = JSON.stringify(this.listPagesConfig);
        this.selectedSetting.type = "LIST_PAGES";
        let body = this.selectedSetting;
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/setting/save_setting", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);

                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'info',
                        summary: $localize`:@@Save_Success:Save Success`,
                        detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                    });


                } else if (res["status"] == 400) {

                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;


        });
    }

    loadDashBoardSetting() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/setting/get_setting?" +
            "&type=DASHBOARD");
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.selectedSetting = res["entity"];
                    if (this.selectedSetting.data != null) {
                        this.dashboardSetting = JSON.parse(this.selectedSetting.data);
                    }

                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    saveDashboardSetting() {
        let params = {};
        this.selectedSetting.data = JSON.stringify(this.dashboardSetting);
        this.selectedSetting.type = "DASHBOARD";
        let body = this.selectedSetting;
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/setting/save_setting", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);

                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'info',
                        summary: $localize`:@@Save_Success:Save Success`,
                        detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                    });


                } else if (res["status"] == 400) {

                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;


        });
    }

}
